<template>
<vue-markdown>
#### 开发文档

部分接口[在此](https://fzlee.gitbooks.io/goods/content/)


####  重复订单的处理
  如果订单进入了拼板以及之后的流程，且再次收到了第三方公司的同样订单，我们将会直接拒绝接受这个订单。
  如果订单位于拼板之前的流程， 我们会立即更新这个订单的信息以及文件。
</vue-markdown>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'help-other',
  components: {
    'vue-markdown': VueMarkdown
  }
}
</script>